<template>
  <div class="card timeline-card">
    <slot name="title" />
    <slot name="no-data" />
    <ScrollableList
      class="timeline-scrollable"
      :items="data"
      :item-key="(key, index) => index"
      :scroll-to-Index
    >
      <template #list-item="{ item, index }">
        <div
          class="timeline-item"
          :class="{
            active: index === currentIndex,
          }"
          @click="handleOnClick(item.time)"
        >
          <TranscriptionParagraphHeader
            class="timeline-item-header"
            :timestamp="item.time"
            :speaker="item.speaker"
          />
          <TranscriptionParagraphContent
            v-if="showContent && item.text"
            :content="item.text"
          />
        </div>
      </template>
    </ScrollableList>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import ScrollableList from "../../reusable/molecules/ScrollableList.vue";
import TranscriptionParagraphContent from "../atoms/TranscriptionParagraphContent.vue";
import TranscriptionParagraphHeader from "../atoms/TranscriptionParagraphHeader.vue";

type TimeLineItem = {
  time: number;
  speaker?: string;
  text?: string;
};

type TranscriptionTimeLineProps = {
  currentTime: number;
  data: TimeLineItem[];
  showContent?: boolean;
};

const {
  data,
  currentTime,
  showContent = true,
} = defineProps<TranscriptionTimeLineProps>();

const autoScroll = defineModel<boolean>("autoScroll", { default: false });

const emit = defineEmits<{ timeChanged: [number] }>();

const handleOnClick = (timestamp: number) => {
  emit("timeChanged", timestamp);
};

const currentIndex = computed(() => {
  if (!data.length) {
    return undefined;
  }

  const nextChunkIndex = data.findIndex((t) => currentTime < t.time);
  if (nextChunkIndex === -1) {
    return data.length - 1;
  }

  if (nextChunkIndex === 0) {
    return undefined;
  }

  return nextChunkIndex - 1;
});

const scrollToIndex = computed(() =>
  autoScroll.value ? currentIndex.value : undefined
);
</script>

<style scoped lang="scss">
.timeline-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px;

  .timeline-controls {
    margin-top: 4px;
    display: flex;
    justify-content: flex-end;
  }
  .timeline-scrollable {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    margin-left: -10px;
    margin-right: -10px;

    .timeline-item {
      cursor: pointer;
      padding: 7px 10px;

      &:hover {
        background-color: var(--clr-s1);
      }
      &.active {
        background-color: var(--clr-s2);
      }
      .transcription-controls {
        position: sticky;
        top: 0;
      }
      .timeline-item-header {
        padding-bottom: 4px;
      }
    }
  }
}
</style>
